
import { Route, Switch } from 'react-router-dom/cjs/react-router-dom.min';
import './App.css';

import HomePage from './components/HomePage';
import PageHead from './components/PageHead';




function App() {
  return (
<div style={{backgroundColor:"white"}}>
 <PageHead/>
 <HomePage/>

 
</div>
   
  

  );
}

export default App;
